"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductGroupPage = exports.default = void 0;

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _react = _interopRequireWildcard(require("react"));

var _decorators = require("decorators");

var _base = _interopRequireWildcard(require("block/base"));

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _CatalogGroupPage = require("CatalogGroupPage");

var _CatalogGroup = require("pages/CatalogGroup");

var _Cart = babelHelpers.interopRequireDefault(require("Cart"));

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _dec, _dec2, _class3, _descriptor9, _descriptor10, _descriptor11;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || babelHelpers.typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = babelHelpers.getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = babelHelpers.getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return babelHelpers.possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var ProductGroup = (_dec = (0, _decorators.alias)("content.type"), _dec2 = (0, _decorators.alias)("content.name"), (_class3 = /*#__PURE__*/function (_Component2) {
  babelHelpers.inherits(ProductGroup, _Component2);

  var _super2 = _createSuper(ProductGroup);

  function ProductGroup() {
    var _this2;

    babelHelpers.classCallCheck(this, ProductGroup);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(args));
    babelHelpers.initializerDefineProperty(_this2, "content", _descriptor9, babelHelpers.assertThisInitialized(_this2));
    babelHelpers.initializerDefineProperty(_this2, "type", _descriptor10, babelHelpers.assertThisInitialized(_this2));
    babelHelpers.initializerDefineProperty(_this2, "name", _descriptor11, babelHelpers.assertThisInitialized(_this2));
    return _this2;
  }

  babelHelpers.createClass(ProductGroup, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement(ProductGroupPage, this.content);
    }
  }]);
  return ProductGroup;
}(_react.Component), (_descriptor9 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "content", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "type", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "name", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class3));
exports.default = ProductGroup;
var ProductGroupPage = (_class = /*#__PURE__*/function (_Component) {
  babelHelpers.inherits(ProductGroupPage, _Component);

  var _super = _createSuper(ProductGroupPage);

  function ProductGroupPage() {
    var _this;

    babelHelpers.classCallCheck(this, ProductGroupPage);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    babelHelpers.initializerDefineProperty(_this, "background", _descriptor, babelHelpers.assertThisInitialized(_this));
    babelHelpers.initializerDefineProperty(_this, "id", _descriptor2, babelHelpers.assertThisInitialized(_this));
    babelHelpers.initializerDefineProperty(_this, "spotlight", _descriptor3, babelHelpers.assertThisInitialized(_this));
    babelHelpers.initializerDefineProperty(_this, "subHeadline", _descriptor4, babelHelpers.assertThisInitialized(_this));
    babelHelpers.initializerDefineProperty(_this, "headline", _descriptor5, babelHelpers.assertThisInitialized(_this));
    babelHelpers.initializerDefineProperty(_this, "summary", _descriptor6, babelHelpers.assertThisInitialized(_this));
    babelHelpers.initializerDefineProperty(_this, "catalogGroup", _descriptor7, babelHelpers.assertThisInitialized(_this));
    babelHelpers.initializerDefineProperty(_this, "footerBlocks", _descriptor8, babelHelpers.assertThisInitialized(_this));
    return _this;
  }

  babelHelpers.createClass(ProductGroupPage, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        id: "page-content-container"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: _classList.default.join('block', 'stack', 'header-block', this.background && 'variable-background'),
        "data-landing-page-group": this.id,
        "data-block-type": "header",
        style: this.background ? _base.default.styleForBackgroundObject(this.background) : {}
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "spotlight-header"
      }, this.spotlight && /*#__PURE__*/_react.default.createElement(_CatalogGroup.SpotlightCarousel, this.spotlight), /*#__PURE__*/_react.default.createElement("div", {
        className: "inner-content animate-fadeIn"
      }, /*#__PURE__*/_react.default.createElement("h1", {
        className: "title"
      }, this.headline), this.summary && /*#__PURE__*/_react.default.createElement("h2", null, /*#__PURE__*/_react.default.createElement(SummaryValue, {
        value: this.summary
      }))))), /*#__PURE__*/_react.default.createElement("div", {
        className: "block stack height-auto"
      }, /*#__PURE__*/_react.default.createElement("div", {
        id: "catalogGroupPage"
      }, /*#__PURE__*/_react.default.createElement(_CatalogGroupPage.CatalogGroupPage, _extends({
        className: "stack catalog-group"
      }, this.catalogGroup)))), /*#__PURE__*/_react.default.createElement(require(this.footerBlocks.child_type).default, this.footerBlocks));
    }
  }]);
  return ProductGroupPage;
}(_react.Component), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "background", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "id", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "spotlight", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "subHeadline", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "headline", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "summary", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "catalogGroup", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "footerBlocks", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
exports.ProductGroupPage = ProductGroupPage;

function SummaryValue(_ref) {
  var value = _ref.value;
  if (typeof value == 'string') return value;
  return value.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
      key: index
    }, index > 0 ? ' / ' : '', /*#__PURE__*/_react.default.createElement("a", {
      href: item.link
    }, item.title));
  });
}